import React, {Component} from 'react';
import PropTypes from 'prop-types';

require("./OddscheckerWidget.scss");

export default class OddscheckerWidget extends Component {

    componentDidMount() {
      const hash = this.props.hash || "";
      if (window && window.ocBootstrap && window.ocBootstrap.scrapePage) {
        window.ocBootstrap.scrapePage(hash);
      }
    }

    render() {
      const hash = this.props.hash || "";
      const className = `ocw ${hash} ${this.props.isFooter ? 'oc-banner' : ''}`;

      return (
        <div className={className}></div>
      );
    }

}

OddscheckerWidget.propTypes = {
    hash: PropTypes.string.isRequired,
    isFooter: PropTypes.bool,
}

OddscheckerWidget.defaultProps = {
  className: '',
  isFooter: false,
}



// WEBPACK FOOTER //
// ./modules/Common/components/OddscheckerWidget.js